module.exports = __webpack_public_path__ + "img/kaifa.f6b89528.png";